import React from 'react';
import { Paragraph } from '../Typography2';
import { Link } from 'react-router-dom';
import './style.scss';
import { ISearchResult } from './types';
import ImageLoader from '../ImageLoader';

const SearchResult: React.FC<ISearchResult> = ({
  imgSrc,
  isDisabled,
  title,
  subtitle,
  description,
  id,
  type,
  uuid,
  slug,
}) => {
  const linkId = type === 'curators' ? uuid : slug || uuid || id;

  const handleClick = () => {
    if (!isDisabled && linkId) {
      const fullUrl = `${window.location.origin}/exhibitions/${linkId}`;
      // console.log('fullUrl => ', fullUrl);
      window.open(fullUrl, '_blank', 'noopener,noreferrer');
    }
  };

  const content = (
    <>
      <div className="img">
        <ImageLoader
          imgUrls={imgSrc && Array.isArray(imgSrc) ? [...imgSrc] : [imgSrc]}
        />
      </div>
      <div className="searchDetails">
        <Paragraph className="searchTitle" value={title} />
        <Paragraph className="gray searchSubtiltle" value={subtitle} />
        <Paragraph className="searchDescription" value={description} />
      </div>
    </>
  );

  return (
    <div className="borderBottom">
      {type === 'exhibitions' ? (
        <div
          className="search-result container"
          role="button"
          tabIndex={0}
          onClick={handleClick}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleClick();
          }}
        >
          {content}
        </div>
      ) : (
        <Link
          to={!isDisabled ? `/${type}/${linkId}` : ''}
          className="search-result container"
        >
          {content}
        </Link>
      )}
    </div>
  );
};

export default SearchResult;